export default __webpack_public_path__ + "static/media/bg-all.fefe0308.jpg";